// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enroll_enrollContainer__vpFKP {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fff;
}

.enroll_enrollContainer__vpFKP {
  padding: 20px;
  font-family: "Segoe UI", sans-serif;
  color: #333;
}

/* ===== Header Block ===== */
.enroll_enrollHeader__cKNYJ {
  width: 100%;
  padding: 0;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.enroll_enrollTitle__8uauw {
  font-size: 24px;
  line-height: 1.2;
  color: #888;
  margin-bottom: 10px;
  display: block;
}

.enroll_easyPayHeader__744Il {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  text-align: center;
}

.enroll_headerText__iq20c {
  font-size: 18px;
  font-weight: 500;
  color: #444;
}
@media (min-width: 992px) {
  .enroll_headerText__iq20c {
    font-size: 20px;
  }
}

.enroll_settingsLink__uepsP {
  font-size: 16px;
  font-weight: 500;
  background-color: #9e9e9e !important;
  color: #fff;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none !important;
}
.enroll_settingsLink__uepsP a {
  text-decoration: none !important;
  color: unset !important;
}

/* ===== Setup Block ===== */
.enroll_setupBlock__TgEEG {
  margin-bottom: 20px;
}

.enroll_sectionTitle__j-fYp {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #9e9e9e;
}

.enroll_sectionSubtitle__V6HbT {
  font-size: 18px;
  color: #9e9e9e;
  margin-bottom: 6px;
  display: block;
}

/* ===== Selection Block ===== */
.enroll_selectionBlock__dBpvg {
  background-color: #f9f9f9;
}

.enroll_selectAll__FqRLZ {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.enroll_selectAll__FqRLZ input {
  margin-right: 8px;
}

.enroll_serviceItem__EgdhZ {
  border-top: 1px solid #eee;
  padding-top: 12px;
  margin-top: 12px;
}
.enroll_serviceItem__EgdhZ .enroll_serviceName__lTd0c {
  font-size: 16px;
  font-weight: 600;
}
.enroll_serviceItem__EgdhZ .enroll_servicePrice__uC8mN {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}
.enroll_serviceItem__EgdhZ .enroll_serviceNote__o\\+JER {
  font-size: 14px;
  color: #333;
  margin-top: 2px;
}
.enroll_serviceItem__EgdhZ .enroll_serviceNoteSmall__L70TF {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

/* ===== Payment Block ===== */
.enroll_paymentBlock__fbTEz {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 6px;
}

.enroll_paymentTitle__SKb85 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}

.enroll_paymentOption__q94tO {
  font-size: 16px;
  margin-bottom: 10px;
}
.enroll_paymentOption__q94tO input {
  margin-right: 10px;
}

/* ===== Button Group ===== */
.enroll_buttonGroup__aB7aF {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.enroll_buttonGroup__aB7aF button {
  font-size: 16px;
  padding: 8px 20px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}
.enroll_buttonGroup__aB7aF button.enroll_cancel__KbO1j {
  background-color: #ccc;
  color: #333;
  margin-right: 10px;
}
.enroll_buttonGroup__aB7aF button.enroll_submit__BtV0n {
  background-color: #007bff;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/styles/enroll.module.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAGA;EACI,aAAA;EACA,mCAAA;EACA,WAAA;AAAJ;;AAGA,6BAAA;AACA;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAAJ;;AAIA;EACI,eAAA;EACA,gBAAA;EAEA,WAAA;EACA,mBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAFJ;AAII;EALJ;IAMQ,eAAA;EADN;AACF;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AADJ;AAGI;EACI,gCAAA;EACA,uBAAA;AADR;;AAOA,4BAAA;AACA;EACI,mBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAJJ;;AAOA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AAJJ;;AAOA,gCAAA;AACA;EACI,yBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAJJ;AAMI;EACI,iBAAA;AAJR;;AAQA;EACI,0BAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AAOI;EACI,eAAA;EACA,gBAAA;AALR;AAQI;EACI,eAAA;EACA,WAAA;EACA,eAAA;AANR;AASI;EACI,eAAA;EACA,WAAA;EACA,eAAA;AAPR;AAUI;EACI,eAAA;EACA,WAAA;EACA,eAAA;AARR;;AAYA,8BAAA;AACA;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AATJ;;AAYA;EACI,eAAA;EACA,mBAAA;AATJ;AAWI;EACI,kBAAA;AATR;;AAaA,6BAAA;AACA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;AAVJ;AAYI;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAVR;AAYQ;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;AAVZ;AAaQ;EACI,yBAAA;EACA,WAAA;AAXZ","sourcesContent":[".enrollContainer {\n    border: 1px solid #ccc; // light gray border\n    border-radius: 8px; // rounded corners\n    padding: 20px; // spacing inside\n    margin-bottom: 20px; // spacing outside\n    background-color: #fff; // optional, keeps it clean\n}\n\n\n.enrollContainer {\n    padding: 20px;\n    font-family: 'Segoe UI', sans-serif;\n    color: #333;\n}\n\n/* ===== Header Block ===== */\n.enrollHeader {\n    width: 100%;\n    padding: 0;\n    text-align: center;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n\n}\n\n.enrollTitle {\n    font-size: 24px;\n    line-height: 1.2;\n\n    color: #888;\n    margin-bottom: 10px;\n    display: block;\n}\n\n.easyPayHeader {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.headerText {\n    font-size: 18px;\n    font-weight: 500;\n    color: #444;\n\n    @media (min-width: 992px) {\n        font-size: 20px;\n    }\n}\n\n.settingsLink {\n    font-size: 16px;\n    font-weight: 500;\n    background-color: #9e9e9e !important;\n    color: #fff;\n    padding: 6px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    white-space: nowrap;\n    text-decoration: none !important;\n\n    a {\n        text-decoration: none !important;\n        color: unset !important\n    }\n\n\n}\n\n/* ===== Setup Block ===== */\n.setupBlock {\n    margin-bottom: 20px;\n}\n\n.sectionTitle {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: #9e9e9e;\n}\n\n.sectionSubtitle {\n    font-size: 18px;\n    color: #9e9e9e;\n    margin-bottom: 6px;\n    display: block;\n}\n\n/* ===== Selection Block ===== */\n.selectionBlock {\n    background-color: #f9f9f9;\n}\n\n.selectAll {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n\n    input {\n        margin-right: 8px;\n    }\n}\n\n.serviceItem {\n    border-top: 1px solid #eee;\n    padding-top: 12px;\n    margin-top: 12px;\n\n    .serviceName {\n        font-size: 16px;\n        font-weight: 600;\n    }\n\n    .servicePrice {\n        font-size: 14px;\n        color: #666;\n        margin-top: 4px;\n    }\n\n    .serviceNote {\n        font-size: 14px;\n        color: #333;\n        margin-top: 2px;\n    }\n\n    .serviceNoteSmall {\n        font-size: 12px;\n        color: #999;\n        margin-top: 2px;\n    }\n}\n\n/* ===== Payment Block ===== */\n.paymentBlock {\n    margin-top: 10px;\n    background-color: #fff;\n    border-radius: 6px;\n}\n\n.paymentTitle {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 12px;\n}\n\n.paymentOption {\n    font-size: 16px;\n    margin-bottom: 10px;\n\n    input {\n        margin-right: 10px;\n    }\n}\n\n/* ===== Button Group ===== */\n.buttonGroup {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n\n    button {\n        font-size: 16px;\n        padding: 8px 20px;\n        border-radius: 4px;\n        border: none;\n        cursor: pointer;\n\n        &.cancel {\n            background-color: #ccc;\n            color: #333;\n            margin-right: 10px;\n        }\n\n        &.submit {\n            background-color: #007bff;\n            color: #fff;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"enrollContainer": `enroll_enrollContainer__vpFKP`,
	"enrollHeader": `enroll_enrollHeader__cKNYJ`,
	"enrollTitle": `enroll_enrollTitle__8uauw`,
	"easyPayHeader": `enroll_easyPayHeader__744Il`,
	"headerText": `enroll_headerText__iq20c`,
	"settingsLink": `enroll_settingsLink__uepsP`,
	"setupBlock": `enroll_setupBlock__TgEEG`,
	"sectionTitle": `enroll_sectionTitle__j-fYp`,
	"sectionSubtitle": `enroll_sectionSubtitle__V6HbT`,
	"selectionBlock": `enroll_selectionBlock__dBpvg`,
	"selectAll": `enroll_selectAll__FqRLZ`,
	"serviceItem": `enroll_serviceItem__EgdhZ`,
	"serviceName": `enroll_serviceName__lTd0c`,
	"servicePrice": `enroll_servicePrice__uC8mN`,
	"serviceNote": `enroll_serviceNote__o+JER`,
	"serviceNoteSmall": `enroll_serviceNoteSmall__L70TF`,
	"paymentBlock": `enroll_paymentBlock__fbTEz`,
	"paymentTitle": `enroll_paymentTitle__SKb85`,
	"paymentOption": `enroll_paymentOption__q94tO`,
	"buttonGroup": `enroll_buttonGroup__aB7aF`,
	"cancel": `enroll_cancel__KbO1j`,
	"submit": `enroll_submit__BtV0n`
};
export default ___CSS_LOADER_EXPORT___;
